(()=>{
  if(window.__faLiveHome)return;window.__faLiveHome=1;
  const ready=(fn)=>document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn,{once:true}):fn();
  ready(()=>{
    document.querySelectorAll('[data-fa-live-hero]').forEach(root=>{
      const track=root.querySelector('[data-fa-hero-track]');const slides=[...root.querySelectorAll('[data-fa-hero-slide]')];const dots=[...root.querySelectorAll('[data-fa-hero-dot]')];if(!track||slides.length<2)return;
      let index=0,timer;const show=(next)=>{index=(next+slides.length)%slides.length;track.style.transform=`translateX(-${index*100}%)`;dots.forEach((d,i)=>d.setAttribute('aria-current',i===index?'true':'false'));};
      let inView=true;const restart=()=>{clearInterval(timer);const delay=Number(root.dataset.autoplay||0);if(delay>0&&inView&&!document.hidden&&!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>show(index+1),delay)};if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;if(inView)restart();else clearInterval(timer);},{threshold:0.05});observer.observe(root);}
      root.querySelector('[data-fa-hero-prev]')?.addEventListener('click',()=>{show(index-1);restart()});root.querySelector('[data-fa-hero-next]')?.addEventListener('click',()=>{show(index+1);restart()});dots.forEach((d,i)=>d.addEventListener('click',()=>{show(i);restart()}));restart();root.addEventListener('mouseenter',()=>clearInterval(timer));root.addEventListener('mouseleave',restart);document.addEventListener('visibilitychange',()=>document.hidden?clearInterval(timer):restart());
    });
    document.querySelectorAll('[data-fa-live-finder]').forEach(form=>form.addEventListener('submit',event=>{
      event.preventDefault();
      const occasion=form.querySelector('[name="occasion"]');
      const budget=form.querySelector('[name="budget"]');
      const option=occasion?.selectedOptions?.[0];
      const configured=option?.dataset.collectionHandle||'';
      const fallback=form.dataset.fallback||'best-seller';
      const handle=/^[a-z0-9][a-z0-9-]*$/.test(configured)?configured:(/^[a-z0-9][a-z0-9-]*$/.test(fallback)?fallback:'best-seller');
      const params=new URLSearchParams();
      const value=budget?.value||'';
      if(/^[0-9]+-[0-9]+$/.test(value)){
        const [min,max]=value.split('-').map(Number);
        if(min>0)params.set('filter.v.price.gte',String(min));
        if(max<999999)params.set('filter.v.price.lte',String(max));
      }
      const url='/collections/'+handle+(params.size?'?'+params.toString():'');
      window.location.assign(url);
    }));
    document.querySelectorAll('[data-fa-scroll]').forEach(root=>{
      const track=root.querySelector('[data-fa-scroll-track]');if(!track)return;
      const prev=root.querySelector('[data-fa-scroll-prev]');const next=root.querySelector('[data-fa-scroll-next]');
      const step=()=>Math.max(track.clientWidth*.75,240);
      let syncQueued=false;
      const sync=()=>{
        if(syncQueued)return;
        syncQueued=true;
        requestAnimationFrame(()=>{
          syncQueued=false;
          const viewportWidth=track.clientWidth;
          const scrollWidth=track.scrollWidth;
          const scrollLeft=track.scrollLeft;
          const overflow=scrollWidth>viewportWidth+4;
          const atStart=scrollLeft<=2;
          const atEnd=scrollLeft+viewportWidth>=scrollWidth-2;
          if(prev){
            if(prev.hidden!==!overflow)prev.hidden=!overflow;
            if(prev.disabled!==atStart)prev.disabled=atStart;
          }
          if(next){
            if(next.hidden!==!overflow)next.hidden=!overflow;
            if(next.disabled!==atEnd)next.disabled=atEnd;
          }
        });
      };
      prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
      next?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
      track.addEventListener('scroll',sync,{passive:true});
      if('ResizeObserver'in window)new ResizeObserver(sync).observe(track);else window.addEventListener('resize',sync,{passive:true});
      root.querySelectorAll('img').forEach(image=>{if(!image.complete)image.addEventListener('load',sync,{once:true})});
      if('requestIdleCallback' in window) requestIdleCallback(sync,{timeout:1200}); else sync();
    });
    document.querySelectorAll('[data-fa-seo-toggle]').forEach(button=>button.addEventListener('click',()=>{const target=document.getElementById(button.getAttribute('aria-controls'));if(!target)return;const opening=target.hidden;target.hidden=!opening;button.setAttribute('aria-expanded',opening?'true':'false');button.textContent=opening?'Read Less':'Read More';}));
  });
})();
